import { render } from "./others-sidebar.vue?vue&type=template&id=5e75724d"
import script from "./others-sidebar.vue?vue&type=script&lang=js"
export * from "./others-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__